import React from "react";
import PropTypes from "prop-types";
import CalendarTable from "./calendar-table";
import CustomModal from "../../../utils/customModal";
import { getStringDay, getStringMonth } from "../../../utils/functions";
import { useTranslation } from "react-i18next";

import SimpleBar from "simplebar-react";

const CalendarModal = (props) => {
  const { mode, statusCode, date, isOpen, onClose } = props;
  const { t } = useTranslation();
  var calendarDate = new Date(date);
  const stringDate = `${getStringDay(
    calendarDate.getUTCDay()
  )} ${calendarDate.getUTCDate()} de ${getStringMonth(
    calendarDate.getUTCMonth()
  )} del ${calendarDate.getUTCFullYear()}`;
  const modalClass =
    mode == "DDAY" ? "modal-container d-day" : "modal-container repago";

  return (
    <CustomModal
      key={`calendar-${date}-${mode}`}
      show={isOpen}
      handleClose={onClose}
      showClose={true}
    >
      <div className={modalClass}>
        <div className="modal-header">
          <h3>{stringDate.charAt(0).toUpperCase() + stringDate.slice(1)}</h3>
          <span>{t(`general.billStates.${statusCode}`)}</span>
        </div>
        <SimpleBar forceVisible="y" style={{ maxHeight: 300 }}>
          <div className="modal-table">
            <CalendarTable date={date} mode={mode} />
          </div>
        </SimpleBar>
      </div>
    </CustomModal>
  );
};

CalendarModal.propTypes = {
  mode: PropTypes.string.isRequired,
  statusCode: PropTypes.string.isRequired,
  date: PropTypes.string.isRequired,
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default CalendarModal;
